<template>
    <div class="DirectionPageContainer">
        <div class="container">
            <div class="grid">
                <Direction v-for="(card, key) in params.directions" :key="key" :data="card"/>
            </div>

            <div class="row">
                <IconCardsSection title="Как это работает" :params="params.iconCards"/>
            </div>

            <div class="row">
                <ReviewsSliderSection :params="params.reviews"/>
            </div>
        </div>
    </div>
</template>

<script>
import Direction from "../components/cards/Direction";
import IconCardsSection from "../components/sections/IconCardsSection";
import ReviewsSliderSection from "../components/sections/ReviewsSliderSection";

export default {
    name: "DirectionPageContainer",
    components: {ReviewsSliderSection, IconCardsSection, Direction},
    props: ['params'],
    mounted() {
        document.querySelector('body').classList.add('DirectionPage')
    }
}
</script>

<style lang="scss">
.DirectionPage {
    background-color: var(--c-gray-800);

    .page-hero {
        background-color: #f8f9f9;
        color: var(--c-gray-100);
    }
}
</style>

<style scoped lang="scss">
.grid {
    display: grid;
    gap: 30px;
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 100px;

    @include mobile {
        grid-template-columns: 100%;
    }
}
</style>